<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-select
      class="tema-eixo-combo"
      id="temas-select"
      v-model="eixoAux"
      item-text="nome"
      item-name="nome"
      item-value="eixoId"
      :items="eixos.filter((item) => item.nome !== 'Cidade Empreendedora')"
      :label="nome"
      :placeholder="nome"
      :disabled="disabled"
      multiple
      @change="val"
      :rules="[rules]"
      :clearable="true"
    >
      <template v-slot:selection="{ item, index }">
        <span v-if="index < maxDisplay"
          >{{ diminuirValue(item.nome) }} &nbsp;</span
        >
        <span
          v-if="index === maxDisplay"
          class="grey--text caption"
          :label="nome"
          >(+{{ eixoAux.length - maxDisplay }} {{ nome }})</span
        >
      </template>

      <template #item="{ item }">
        <span
          >{{ item.nome }}
          <span class="eixoNaOb" v-if="item.nacional && !item.obrigatorio"
            >(NA)</span
          >
          <span class="eixoNaOb" v-if="item.obrigatorio && !item.nacional"
            >(OB)</span
          >
          <span class="eixoNaOb" v-if="item.obrigatorio && item.nacional"
            >(NA | OB)</span
          >
        </span>
      </template>

      <template slot="no-data"> Nenhum Eixo </template>
    </v-select>
  </v-form>
</template>

<script>
import { eixoAPI } from "../API/eixoAPI";
import { mapActions, mapGetters } from "vuex";
import { municipioEixoApi } from "../API/MunicipioEixo";
import { statusRelacionamentoEnum, statusContratoEnum } from "@/types";

export default {
  name: "AppEixoCombobox",
  props: {
    filter: { type: Object, default: () => ({ eixoId: [] }) },
    isCidadeEmpreendedora: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
    statusRelacionamento: { type: Number, deafult: null },
    nome: { type: String, default: "Eixos" },
  },
  computed: {
    ...mapGetters(["isGov"]),
  },
  async mounted() {
    this.loadMunicipiosEixos();
    if (this.eixos.length === 0) {
      await this.loadEixos()
        .then((resp) => {
          this.eixos = resp.data;
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter Eixos");
        });
    }
  },
  watch: {
    "filter.eixoId": {
      async handler(old, val) {
        if (this.eixos.length === 0) {
          await this.loadEixos()
            .then((resp) => {
              this.eixos = resp.data.filter(
                (item) => item.nome !== "Cidade Empreendedora"
              );
            })
            .catch((resp) => {
              this.$notification.error("Erro ao obter Eixos");
            });
        }
        if (old) {
          this.eixoVerify(
            parseInt(this.isCidadeEmpreendedora) ===
              this.statusRelacionamentoEnum.negociacao
          );
        }
      },
      deep: true,
    },
    async "filter.statusContratoId"(old, val) {
      if (this.eixos.length === 0) {
        await this.loadEixos()
          .then((resp) => {
            this.eixos = resp.data.filter(
              (item) => item.nome !== "Cidade Empreendedora"
            );
          })
          .catch((resp) => {
            this.$notification.error("Erro ao obter Eixos");
          });
      }
      this.eixoVerify(old === 2);
    },
  },

  methods: {
    ...mapActions(["setLoading"]),
    val(val) {
      this.filter.eixoId = this.eixos
        .filter((item) => val.includes(item.eixoId))
        .map((val) => {
          let pergunta = "Sem Resposta";
          if (
            this.municipioEixos.filter((m) => m.eixoId == val.eixoId).length > 0
          ) {
            pergunta = this.municipioEixos.filter(
              (m) => m.eixoId == val.eixoId
            )[0].pergunta;
          }
          return {
            ...val,
            pergunta: pergunta,
          };
        });

      this.$emit("eixoChange", this.filter.eixoId);
    },
    diminuirValue(item) {
      if (item && item.length > 12) {
        return item.substring(0, 12) + "...";
      }

      return item;
    },
    eixoVerify(isCidadeEmpreendedora) {
      let eixoAux = this.filter.eixoId ? [...this.filter.eixoId] : [];
      if (isCidadeEmpreendedora) {
        for (let i = 0; i < eixoAux.length; i++) {
          for (let j = 0; j < this.eixos.length; j++) {
            if (
              this.eixos[j].eixoId === eixoAux[i].eixoId &&
              this.eixos[j].obrigatorio
            ) {
              eixoAux.splice(i, 1);
            }
          }
        }

        this.eixos
          .filter((item) => item.obrigatorio)
          .forEach((item) => {
            item.disabled = true;
          });
        this.eixoAux = [
          ...eixoAux,
          ...this.eixos.filter((item) => item.obrigatorio),
        ];
      } else {
        this.eixoAux = this.filter.eixoId ? [...this.filter.eixoId] : [];
        this.eixos.forEach((eixo) => {
          eixo.disabled = false;
        });
      }
    },
    rules(value) {
      if (this.statusRelacionamento == this.statusRelacionamentoEnum.vigente) {
        if (value.length === 0) {
          return "Você precisa escolher pelo menos 1 eixo obrigatório";
        }
        return true;
        // } else if (parseInt(this.isCidadeEmpreendedora) === 1) {
        //   if (value.length === 0) {
        //     return "Você precisa escolher pelo menos 2 eixos obrigatórios";
        //   } else if (value.length > 0) {
        //     let eixosObrigatorios = 0;
        //     for (let i = 0; i < value.length; i++) {
        //       for (let j = 0; j < this.eixos.length; j++) {
        //         if (this.eixos[j].eixoId === value[i]) {
        //           if (this.eixos[j].obrigatorio) {
        //             eixosObrigatorios++;
        //           }
        //         }
        //       }
        //     }
        //     if (eixosObrigatorios >= 2) {
        //       return true;
        //     } else {
        //       return "Você precisa escolher pelo menos 2 eixos obrigatórios";
        //     }
        //   } else {
        //     return true;
        //   }
        // } else {
        //   return true;
      }
    },
    loadEixos() {
      return eixoAPI.list();
    },
    loadMunicipiosEixos() {
      this.setLoading(true);
      municipioEixoApi
        .list()
        .then((resp) => {
          if (resp.data.length) {
            this.filter.eixoId = resp.data.filter(
              (item) =>
                parseInt(item.municipioId) === parseInt(this.$route.params.id)
            );
            this.eixoAux = this.filter.eixoId ? [...this.filter.eixoId] : [];

            this.municipioEixos = this.filter.eixoId;
          }

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar municipiosEixos");
        });
    },
    validate() {
      return this.$refs.form.validate();
    },
  },
  data() {
    return {
      eixos: [],
      valid: true,
      eixoAux: [],
      maxDisplay: 1,
      municipioEixos: [],
      statusRelacionamentoEnum: statusRelacionamentoEnum,
    };
  },
};
</script>

<style scoped>
.eixoNaOb {
  font-size: 12px;
  font-weight: bold;
}
</style>
